import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import LabCard from '../components/LabCard';
import axios from 'axios';



function LabPage() {
  const { locationName } = useParams();
  const [locationLabs, setLocationLabs] = useState([]);



  useEffect(() => {
    axios.get(process.env.REACT_APP_API_BASE_URL + "/labs/")
      .then(response => {
        const filtered = response.data.filter(
          lab => lab.location === locationName
        );
        setLocationLabs(filtered);
      })
      .catch(error => console.log(error));
  }, [locationName]);

  return (
    <div className="container" style={{ minHeight: '60vh' }}>




      {locationLabs.length > 0 ? (
        <div>
          {locationLabs.map(lab => (
            <LabCard key={lab._id} lab={lab} />
          ))}
        </div>
      ) : (
        <div className="alert alert-warning">No labs found for this location.</div>
      )}
    </div>
  );
}

export default LabPage;